const redirectStatus = /* @__PURE__ */ new Set([301, 302, 303, 307, 308]);
const isRedirect = (code) => {
  return redirectStatus.has(code);
};
export {
  isRedirect
};
//# sourceMappingURL=is-redirect.js.map
